export default "__VITE_ASSET__BLivVuwk__"